<template>
    <div name="basic-pc">
        <!-- <linebanner /> -->
        <navigation />
        <mainbanner />
        <!-- <SoldocPartnersEffect /> -->
        <SoldocAppQrcode />
        <DescriptionOfSoldoc1 />
        <DescriptionOfSoldoc2 />
        <DescriptionOfSoldoc3 />
        <SoldocFunction />
        <SoldocPartnersReview />
        <SoldocCertification />
        <!-- <benefit /> -->    
        <!-- <introduction /> -->
        <!-- <function /> -->
        <!-- <result /> -->
        <!-- <healthcare /> -->
        <!-- <review /> -->
        <!-- <advantage /> -->
        <media-soldoc />
        <infra-contact />
        <faq />
        <partners-footer />
        <!-- <popup /> -->
    </div>
</template>

<script>
// import Linebanner from "@/components/pc_partners/Linebanner";
import Navigation from "@/components/pc_partners/Navigation";
import Mainbanner from "@/components/pc_partners/Mainbanner";
// import SoldocPartnersEffect from "@/components/pc_partners/SoldocPartnersEffect";
import SoldocAppQrcode from "@/components/pc_partners/SoldocAppQrcode";
import DescriptionOfSoldoc1 from "@/components/pc_partners/DescriptionOfSoldoc1";
import DescriptionOfSoldoc2 from "@/components/pc_partners/DescriptionOfSoldoc2";
import DescriptionOfSoldoc3 from "@/components/pc_partners/DescriptionOfSoldoc3";
import SoldocFunction from "@/components/pc_partners/SoldocFunction";
import SoldocPartnersReview from "@/components/pc_partners/SoldocPartnersReview";
import SoldocCertification from "@/components/pc_partners/SoldocCertification";
// import Benefit from "@/components/pc_partners/Benefit";
// import Introduction from "@/components/pc_partners/Introduction";
// import Function from "@/components/pc_partners/Function";
// import Result from "@/components/pc_partners/Result";
// import Healthcare from "@/components/pc_partners/Healthcare";
// import Review from "@/components/pc_partners/Review";
// import Advantage from "@/components/pc_partners/Advantage";
import MediaSoldoc from "@/components/pc_partners/MediaSoldoc";
import InfraContact from "@/components/pc_partners/InfraContact";
import Faq from "@/components/pc_partners/FaQ";
import PartnersFooter from "@/components/pc_partners/PartnersFooter";
// import Popup from "@/components/pc_partners/Popup";

export default {
    name: "basicPc",
    components: {
        // Linebanner,
        Navigation,
        Mainbanner,
        // SoldocPartnersEffect,
        SoldocAppQrcode,
        DescriptionOfSoldoc1,
        DescriptionOfSoldoc2,
        DescriptionOfSoldoc3,
        SoldocFunction,
        SoldocPartnersReview,
        SoldocCertification,
        // Benefit,
        // Introduction,
        // Function,
        // Result,
        // Healthcare,
        // Review,
        // Advantage,
        MediaSoldoc,
        InfraContact,
        Faq,
        PartnersFooter,
        // Popup,
    },
    mounted: function() {
        // $("html").animate(
        //     {
        //         scrollTop: 0,
        //     },
        //     300
        // );
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/PcPartners.vue